'use client'

import classNames from 'classnames'
import React from 'react'

import Form from '~/components/form'
import RichText from '~/components/rich-text'
import RightModal from '~/components/right-modal/right-modal'
import Title from '~/components/title'
import { IFormModal } from '~/types/form'

import DashedDivider from '../dashed-divider/dashed-divider'

interface IProperties {
  modalData: IFormModal
  isActive: boolean
  onClose: () => void
  fixOverflow?: boolean
}

const FormModal: React.FC<IProperties> = ({
  isActive,
  modalData,
  onClose,
  fixOverflow = true,
}) => {
  const variant = modalData.variant ?? 'gray'

  return (
    <RightModal onClose={onClose} isActive={isActive} fixOverflow={fixOverflow}>
      <div className="flex flex-col text-left min-h-full flex-auto">
        <div className="flex flex-col text-neutral-black items-start gap-4 lg:gap-5 pt-14 pb-10 px-6 lg:px-16">
          {modalData.tag && <p className="uppercase">{modalData.tag}</p>}
          <Title
            Tag={'h2'}
            html={modalData.title}
            className="font-sans-12 text-6xl leading-[0.9]"
          />
          <RichText html={modalData.description} />
        </div>
        <DashedDivider />
        {modalData.ukForm?.data?.attributes && (
          <Form
            formData={modalData.ukForm.data.attributes}
            formId={modalData.ukForm.data.id}
            formPrefix={`modal-${modalData.id}-`}
            isHidden={!isActive}
            className={classNames('flex-auto h-full py-12 px-6 lg:px-16', {
              'text-neutral-white bg-wine-900': variant === 'wine',
              'bg-gray-200 text-neutral-black': variant === 'grayish-orange',
              'bg-neutral-200 text-neutral-black': variant === 'gray',
            })}
          />
        )}
      </div>
    </RightModal>
  )
}

export default FormModal
